import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

const getIndex = (array, id) => {
  const mappedArray = array.map(item => item._id);
  return mappedArray.indexOf(id);
}

export const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    projectsFetched: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    projectsAppended: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    addProject: (state, action) => {
      const {data} = action.payload;
      data.customers = [];
      data.customersCount = 0;
      state.entities.unshift(data);
      state.totalCount = state.totalCount + 1;
    },
    editProject: (state, action) => {
      const {id, name} = action.payload;
      const index = getIndex(state.entities, id);
      if (state.entities) {
        state.entities[index].name = name;
      }
    },
    deleteProject: (state, action) => {
      const {id} = action.payload;
      const index = getIndex(state.entities, id);
      if (state.entities) {
        state.entities.splice(index, 1);
      }
      state.totalCount = state.totalCount - 1;
    },
    addCustomerToProject: (state, action) => {
      const {projectId, customerId, name, email} = action.payload;
      const index = getIndex(state.entities, projectId);
      state.entities[index].customers = [...state.entities[index].customers, {_id: customerId, name, email}];
      state.entities[index].customersCount = state.entities[index].customersCount + 1;
    },
    removeCustomerFromProject: (state, action) => {
      const {projectId, customerId} = action.payload;
      const index = getIndex(state.entities, projectId);
      const customerIndex = getIndex(state.entities[index].customers, customerId);
      state.entities[index].customers.splice(customerIndex, 1);
      state.entities[index].customersCount = state.entities[index].customersCount - 1;
    },
    changeCustomersCount: (state, action) => {
      const {projectId, markedCustomers} = action.payload;
      const index = getIndex(state.entities, projectId);

      const customersEmails = Boolean(state.entities[index].customers)
        ? (state.entities[index].customers).map(item => item.email)
        : [];
      const customersToAdd = Boolean(markedCustomers)
        ? markedCustomers.filter(item => !(customersEmails.includes(item.email)))
        : [];
      state.entities[index].customers = [...state.entities[index].customers, ...customersToAdd];
      state.entities[index].customersCount = state.entities[index].customersCount + customersToAdd.length;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
